export { FrequencyCalculatorCTA } from './FrequencyCalculatorCTA';
